import React, { useState } from "react";
import { Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../shared/DashboardWrapper";
import SubjectDetails from "./SubjectDetails";
import "./profile.css";

// Sample static subject data (can be dynamic later via Redux/API)
const subjectData = {
  Mathematics: {
    papersCompleted: "20",
    hoursSpend: "29",
    average: "71%",
    goal: "20%",
    websiteAverage: "20%",
    dayLeft: "20",
    date: "01/10/2024",
    subjectName: "Mathematics",
  },
  English: {
    papersCompleted: "",
    hoursSpend: "",
    average: "",
    goal: "",
    websiteAverage: "",
    dayLeft: "",
    date: "",
    subjectName: "English",
  },
  Science: {
    papersCompleted: "89",
    hoursSpend: "49",
    average: "78%",
    goal: "90%",
    websiteAverage: "80%",
    dayLeft: "5",
    date: "01/15/2024",
    subjectName: "Science",
  },
};

const Profile = () => {
  const dispatch = useDispatch(); // ready if you want to dispatch data fetching
  const navigate = useNavigate(); // ready for programmatic navigation

  const [tabKey, setTabKey] = useState("Mathematics");

  const handleTabChange = (key) => {
    setTabKey(key);
  };

  return (
    <DashboardWrapper title="My Profile">
      <div className="tabs">
        <Tabs
          activeKey={tabKey}
          onChange={handleTabChange}
          tabBarStyle={{ borderBottom: "none" }}
          items={[
            {
              key: "Mathematics",
              label: "MATHEMATICS",
              children: (
                <SubjectDetails
                  title={tabKey}
                  data={subjectData.Mathematics}
                  id="goalForMath"
                />
              ),
            },
            {
              key: "English",
              label: "ENGLISH",
              children: (
                <SubjectDetails
                  title={tabKey}
                  data={subjectData.English}
                  id="goalForEnglish"
                />
              ),
            },
            {
              key: "Science",
              label: "SCIENCE",
              children: (
                <SubjectDetails
                  title={tabKey}
                  data={subjectData.Science}
                  id="goalForScience"
                />
              ),
            },
            {
              key: "MotherTongue",
              label: "MOTHER TONGUE",
              children: <p>No data available</p>,
            },
          ]}
        />
      </div>
    </DashboardWrapper>
  );
};

export default Profile;
